import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function HeroSection() {
  const { i18n } = useTranslation();
  const { hero } = getLandingContent(i18n.language);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[85vh] flex items-center bg-gray-900 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={hero.heroImage}
          alt={hero.imageAlt}
          className="w-full h-full object-cover object-top opacity-40"
          width={1400}
          height={900}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-gray-900/90 to-gray-900/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-32 md:py-40">
        <div className="max-w-5xl">
          <p className="text-red-500 text-sm font-medium tracking-widest uppercase mb-6 md:mb-8">
            {hero.eyebrow}
          </p>

          <h1 className="text-[28px] leading-tight sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white break-words mb-8 md:mb-10">
            {hero.title}
            <br />
            <span className="text-white/70">{hero.titleAccent}</span>
          </h1>

          <p className="text-base md:text-lg text-gray-300 max-w-2xl mb-10 md:mb-12 leading-relaxed">
            {hero.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10 md:mb-12">
            <a
              href="#equipment"
              onClick={(e) => handleScroll(e, '#equipment')}
              className="inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent-hover text-white font-medium px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-base"
            >
              <span>{hero.ctaPrimary}</span>
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="#contact"
              onClick={(e) => handleScroll(e, '#contact')}
              className="inline-flex items-center justify-center gap-2 border border-white/25 hover:border-white/50 text-white font-medium px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-base"
            >
              <span>{hero.ctaSecondary}</span>
              <i className="ri-arrow-down-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 md:gap-8">
            {hero.advantages.map((advantage) => (
              <div
                key={advantage}
                className="flex items-center gap-3 text-sm text-gray-300"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0"></span>
                <span>{advantage}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
